import { Injectable } from '@angular/core';

/**
 * Holds a reference to the main scrollable container (`.main-content-area`),
 * registered by the LayoutComponent. Consumers can use it to read or set
 * the scroll position without needing direct DOM access themselves.
 */
@Injectable({
    providedIn: 'root'
})
export class ScrollService {
    private scrollContainer: HTMLElement | null = null;

    public register(element: HTMLElement): void {
        this.scrollContainer = element;
    }

    public getScrollTop(): number {
        return this.scrollContainer?.scrollTop ?? 0;
    }

    public scrollTo(top: number): void {
        if (this.scrollContainer) {
            this.scrollContainer.scrollTop = top;
        }
    }
}
